import { useQuery } from '@tanstack/react-query'
import { Input, Table } from 'antd'
import moment from 'moment'
import React, { useEffect, useState, useRef } from 'react'
import { useTranslation } from 'react-i18next'

import ErrorModal from '@Modal/ErrorModal'
import SuccessModal from '@Modal/SuccessModal'
import { http } from '@services/http'
import { numberWithSpacesIntl } from '@utils/numberWithSpaces'

const PaymentsByPurchaseModal = ({ docEntry, data }) => {
	const { t } = useTranslation()


	const [dataDocEntry, setDataDocEntry] = useState('')

	const fetchDownPayments = async ({ queryKey }) => {
		const [_, docEntry] = queryKey
		if (docEntry) {
			try {
				const url = `api/vendorpayments/by-invoice/${docEntry}`
				const { data } = await http.get(url)
				return data.data
			} catch (error) {
				console.log(error)
			}
		}
	}

	const { data: paymentData = [], isLoading } = useQuery({
		queryKey: [
			'paymentsByPurchase',
			dataDocEntry,
		],
		queryFn: fetchDownPayments,
		keepPreviousData: true,
		refetchOnWindowFocus: false,
	})




	if (!docEntry) return null

	useEffect(() => {
		setDataDocEntry(docEntry)
	}, [docEntry])

	const columns = [
		{
			title: t('date2'),
			dataIndex: 'docDate',
			key: 'docDate',
			render: (text) => moment(text).format('DD.MM.YYYY'),
		},
		{
			title: t('cashs'),
			dataIndex: 'acctName',
			key: 'acctName',
			render: (text) => text,
		},
		{
			title: t('priceSum'),
			dataIndex: 'cashSum',
			key: 'cashSum',
			render: (text, record) => {
				const formattedText = new Intl.NumberFormat('fr-FR').format(
					text,
				)
				return (
					<span>
						{formattedText} {record.docCur}
					</span>
				)
			},
		},
		{
			title: t('currency'),
			dataIndex: 'docCurr',
			key: 'docCurr',
		},
		{
			title: t('comments'),
			dataIndex: 'comments',
			key: 'comments',
		},
	]

	const debt = data?.docTotal - data?.paid
	const currency = data?.docCurr

	return (
		<div className="w-full px-4 ">
			<div className="w-full">
				<div className="flex items-center gap-10  ">
					<div className="mt-4 flex flex-col gap-3 sm:mt-0">
						<p className="font-bold">{t('docTotal')}</p>
						<Input
							value={`${numberWithSpacesIntl(data?.docTotal) ?? ''} ${currency}`}
							style={{ color: 'black' }}
							className="w-[200px]"
							disabled
						/>
					</div>
					<div className="mt-4 flex flex-col gap-3 sm:mt-0">
						<p className="font-bold">{t('paid')}</p>
						<Input
							value={`${numberWithSpacesIntl(data?.paid) ?? ''} ${currency}`}
							style={{ color: 'black' }}
							className="w-[200px]"
							disabled
						/>
					</div>
					<div className="mt-4 flex flex-col gap-3 sm:mt-0">
						<p className="font-bold">{t('debtTotal')}</p>
						<Input
							value={`${numberWithSpacesIntl(debt) ?? ''} ${currency}`}
							style={{ color: 'black' }}
							className="w-[200px]"
							disabled
						/>
					</div>
				</div>
				<Table
					columns={columns}
					dataSource={paymentData}
					pagination={false}
				loading={isLoading}
					className="border-1 mt-5 border-black"
					scroll={{ x: '100%' }}
					bordered
				/>
			</div>

		</div>
	)
}

export default PaymentsByPurchaseModal
